/* eslint-disable @next/next/no-img-element */
import React, { useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';
import Link from 'next/link';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Cookies from 'js-cookie';
import Box from '@material-ui/core/Box';
import { Button, Divider, Typography } from '@material-ui/core';
import { useView } from '../../utility/services/uiHelpers';
import { useRouter } from 'next/router';
import { COMPONENT_NAMES, SCREEN_NAMES, trackAnalyticsEvent } from '../../constants/analyticsMeta';
import { useSignUpStyles } from '../../../pages/get-started';
import { QuattrLogoSpinner } from '../content-ai-tools/components/QuattrLogoSpinner';

export const useOnboardingStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    margin: '0 auto',
    height: '100vh',
    overflow: 'scroll',
    [theme.breakpoints.up('lg')]: {
      maxWidth: '1440px',
    },
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      height: 'unset',
    },
    [theme.breakpoints.between('sm', 'md')]: {
      width: 'auto', // adjust this as needed for tablet screens
      height: 'unset',
    },
  },
  freeTrialRoot: {
    display: 'flex',
    justifyContent: 'center',
    margin: '0 auto',
    height: '100vh',
    overflow: 'scroll',
    [theme.breakpoints.down(1150)]: {
      flexDirection: 'column-reverse',
      alignItems: 'center',
      gap: '40px',
      width: 'auto',
      height: 'unset',
    },
  },
  startFreeTrialWrapper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '0 auto',
    height: '100vh',
    overflowY: 'scroll',
    border: '1px solid red',
    flexDirection: 'row',
    [theme.breakpoints.up('lg')]: {
      maxWidth: '1440px',
    },
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      height: 'unset',
    },
    [theme.breakpoints.down('md')]: {
      width: 'auto',
      height: 'unset',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      width: 'auto', // adjust this as needed for tablet screens
      height: 'unset',
      flexDirection: 'row',
      gap: '40px',
      alignItems: 'center',
    },
  },
  noteDescription: {
    color: '#1D3557',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontWeight: 500,
    padding: '0 20px',
    textAlign: 'center',
    marginTop: '30px',
  },
  noteText: {
    color: 'red',
    textAlign: 'center',
  },
  buyPlanDescription: {
    color: '#1D3557',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontWeight: 500,
    padding: '0 20px',
    textAlign: 'center',
    marginBottom: '20px',
  },
  buyPlan: {
    color: '#51D497',
    textDecoration: 'underline',
    textAlign: 'center',
    cursor: 'pointer',
  },
  overallToolsWrapper: {
    padding: '0 24px',
  },
  sectionOne: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: theme.spacing(2),
      order: 1, // Add this line
    },
    [theme.breakpoints.up('md')]: {
      width: '417px',
    },
  },
  freeTrialSectionOne: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  sectionOneForToolsWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    border: '2px solid #51D497',
    background: '#F6F7F9',
    borderRadius: '10px',
    margin: '0 32px',
    maxWidth: '540px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: theme.spacing(2),
      order: 1, // Add this line
      margin: '0px',
    },
    [theme.breakpoints.up('md')]: {
      width: '417px',
      // marginLeft: '0px',
    },
  },
  sectionTwo: {
    // flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    position: 'relative',
    padding: '0 20px',
    [theme.breakpoints.down('sm')]: {
      order: 2, // Add this line
      padding: theme.spacing(2),
      alignItems: 'center',
      marginTop: '30px',
    },
    '&::after': {
      content: "''",
      display: 'block',
      width: '400px', // Width of the arrow image
      height: '330px', // Height of the arrow image
      backgroundImage: "url('https://qwa-assets.s3.us-east-2.amazonaws.com/up-right-arrow-bg.svg')",
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      position: 'absolute',
      top: '-10%',
      zIndex: -1,
      right: '25%',
      transform: 'rotate(7.831deg)', // Rotate the pseudo-element as needed
      [theme.breakpoints.down('sm')]: {
        // display: 'none'
        width: '80%',
        top: '5%',
        right: '25%',
      },
    },
  },

  freeTrialSectionOneTwo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    position: 'relative',
    padding: '0 20px',
    maxWidth: '590px',
    [theme.breakpoints.down(1410)]: {
      width: 'auto',
    },
    '&::after': {
      content: "''",
      display: 'block',
      width: '400px', // Width of the arrow image
      height: '330px', // Height of the arrow image
      backgroundImage: "url('https://qwa-assets.s3.us-east-2.amazonaws.com/up-right-arrow-bg.svg')",
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      position: 'absolute',
      top: '-10%',
      zIndex: -1,
      right: '25%',
      transform: 'rotate(7.831deg)', // Rotate the pseudo-element as needed

      [theme.breakpoints.down('sm')]: {
        width: '80%',
        top: '5%',
        right: '25%',
      },
    },
  },
  sectionTwoMainHeading: {
    color: '#1D3557',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '42px',
    fontStyle: 'normal',
    fontWeight: 800,
    lineHeight: '140%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '28px',
    },
  },
  sectionTwoMainSubHeading: {
    color: '#1D3557',
    fontFamily: 'Poppins',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 800,
    lineHeight: '140%',
    textAlign: 'center',
    maxWidth: '415px',
    marginTop: '30px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    },
  },
  topHeadingsWrapper: {
    marginTop: '60px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '24px',
      padding: '0 10px',
    },
  },
  topHeading: {
    color: '#51D497',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '48px',
    fontStyle: 'normal',
    fontWeight: 800,
    lineHeight: '140%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '23px',
      fontStyle: 'normal',
      fontWeight: 800,
      lineHeight: '140%',
      padding: '0px 16px',
      marginBottom: '10px',
    },
  },
  topSubHeading: {
    color: '#1D3557',
    fontFamily: 'Poppins',
    fontSize: '28px',
    textAlign: 'center',
    fontStyle: 'normal',
    fontWeight: 800,
    lineHeight: '200%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '21px',
      fontStyle: 'normal',
      fontWeight: 800,
      lineHeight: '140%',
      marginBottom: '10px',
    },
  },
  topDescription: {
    color: '#1D3557',
    fontSize: '18px',
    fontWeight: 500,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      marginBottom: '14px',
    },
  },
  topDescriptionAnchor: {
    color: '#51D497',
    fontSize: '18px',
    textDecoration: 'underline',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  topDescriptionNote: {
    color: '#1D3557',
    fontSize: '14px',
    fontFamily: 'Poppins',
    fontWeight: 500,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: '11px',
    },
  },
  topSubHeadingForTools: {
    color: '#1D3557',
    fontFamily: 'Poppins',
    fontSize: '28px',
    textAlign: 'center',
    fontStyle: 'normal',
    fontWeight: 800,
    marginBottom: '10px',
    lineHeight: '100%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '19px',
      fontStyle: 'normal',
      fontWeight: 800,
      lineHeight: '140%',
      padding: '0px 16px',
    },
    [theme.breakpoints.down(360)]: {
      fontSize: '18px',
      lineHeight: '120%',
      padding: '0px 10px',
    },
  },
  orDivider: {
    color: '#1D3557',
    fontFamily: 'Poppins',
    fontSize: '21px',
    textAlign: 'center',
    fontStyle: 'normal',
    fontWeight: 800,
    lineHeight: '200%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '21px',
      fontStyle: 'normal',
      fontWeight: 800,
      lineHeight: '140%',
      padding: '0px 16px',
    },
  },
  // bg_image_small: {
  //   position: 'absolute',
  //   bottom: '15px',
  //   right: '15px',
  //   [theme.breakpoints.down('sm')]: {
  //     display: 'none',
  //   },
  // },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    padding: '15px 30px',
    background: '#1D3557',
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      // alignItems: 'center',
      paddingBottom: '0px',
      background: '#FFF',
      padding: '0px',
    },
  },
  logo: {
    width: '118px',
    height: '36.48px',
    maxHeight: 55,
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      width: '77px',
      height: '23.99px',
    },
  },
  innerWrap: {
    paddingTop: '20px',
    display: 'flex',
    width: '417px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '24px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      maxWidth: '382px',
    },
  },
  heading: {
    color: '#1D3557',
    fontFamily: 'Poppins',
    fontSize: '28px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    margin: '0px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '24px',
    },
  },
  heading2: {
    fontSize: '22px',
  },
  subText: {
    color: '#212121',
    textAlign: 'left',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
  },
  cmwBanner: {
    padding: '0px',
    margin: '0px',
    fontWeight: 'bold',
    fontSize: '12px',
  },
  link: {
    color: '#212121',
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    textDecorationLine: 'underline',
  },
  primary_action: {
    height: '64px',
    padding: '10.456px 16.265px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '11.618px',
    alignSelf: 'stretch',
    borderRadius: '6.971px',
    background: '#51D497',
    color: '#1D3557',
    fontFamily: 'Poppins',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '20.912px',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#51D497',
    },
  },
  red: {
    color: 'red',
  },
  green: {
    color: '#50D396',
  },
  // new design v1
  featureList: {
    padding: 0,
    margin: theme.spacing(2, 0),
  },
  featureItem: {
    display: 'flex',
    alignItems: 'center',
  },
  featureItemText: {
    color: '#1D3557',
    fontFamily: 'Source Sans Pro',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '160%',
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
  },
  featureIcon: {
    marginRight: theme.spacing(1),
    width: '12px',
    height: '12px',
    color: '#51D497',
  },
  brandsHeading: {
    color: '#51D497',
    textAlign: 'center',
    fontFamily: 'Poppins, sans-serif', // Added fallback font
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    margin: '15px 0px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
      marginTop: '20px',
      marginBottom: '20px',
    },
  },
  brandLogo: {
    // Additional styles for the logos if needed
    margin: theme.spacing(1),
  },
  brandLogosContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  CheckCircleListItemIcon: {
    minWidth: '10px',
  },
  goBack: {
    color: '#1D3557',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '140%',
    width: '289px',
    height: '48px',
    flexShrink: 0,
    borderRadius: '10px',
    border: '2px solid #1D3557',
    textTransform: 'capitalize',
  },
  usageLimit: {
    color: '#1D3557',
    textAlign: 'center',
    fontFamily: '"Source Sans Pro"',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '140%',
  },
  startFreeTrial: {
    color: '#1D3557',
    textAlign: 'center',
    fontFamily: 'Poppins',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '140%',
    width: '289px',
    height: '48px',
    flexShrink: 0,
    borderRadius: '10px',
    background: '#51D497',
    textTransform: 'capitalize',
  },
  exploreToolsSection: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '400px',
    margin: 'auto',
    textAlign: 'center',
  },
  exploreFreeAiToolsBtn: {
    borderRadius: '4.2px',
    background: '#51D497',
    textTransform: 'none',
    padding: '16.8px 33.6px',
  },
}));

const CONSTANTS = {
  brandLogos: [
    {
      src: 'https://qwa-assets.s3.us-east-2.amazonaws.com/coursera+2.svg',
      alt: 'Coursera Logo',
    },
    {
      src: 'https://qwa-assets.s3.us-east-2.amazonaws.com/wp-engine-1+1.svg',
      alt: 'WP Engine Logo',
    },
    {
      src: 'https://qwa-assets.s3.us-east-2.amazonaws.com/simpplr-logo+1.svg',
      alt: 'Simpplr Logo',
    },
    {
      src: 'https://qwa-assets.s3.us-east-2.amazonaws.com/Marriott-International-Logo-1993-2016+1.svg',
      alt: 'Marriot Logo',
    },
    {
      src: 'https://qwa-assets.s3.us-east-2.amazonaws.com/McAfee+1.svg',
      alt: 'McAfee Logo',
    },
  ],
};

const OnboardingComponent = ({ classes, children, showGoBack }) => {
  const isMobile = useView('mobileOnly');
  const signupStyles = useSignUpStyles();
  const Router = useRouter();
  let qttr_tools_auth = Cookies.get('qttr_tools_auth');
  const isFromUnlockOption = Object.keys(Router.query).includes('unlock-options');
  const isSignUpNow = Object.keys(Router.query).includes('signup-now');
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // This makes the scrolling smooth. Remove it if you want instant scroll.
    });
  };
  const handleGoBack = () => {
    const previousUrl = localStorage.getItem('previousUrl');
    if (previousUrl) {
      // Modify the URL to add or update query parameters as needed
      const newUrl = new URL(previousUrl, window.location.origin);
      if (!qttr_tools_auth) {
        newUrl.searchParams.set('verifyEmail', 'true'); // Add or modify query params here
      }
      if (isFromUnlockOption) {
        newUrl.searchParams.set('unlock-options', 'true');
      } else if (isSignUpNow) {
        newUrl.searchParams.set('signup-now', 'true');
      }

      // Use Router.push or Router.replace to navigate
      Router.push(newUrl.pathname + newUrl.search);
    } else {
      // Fallback if no previous URL was stored
      Router.back();
    }
  };
  const goBackAndContinueLabel = !qttr_tools_auth
    ? isFromUnlockOption
      ? 'Verify Email & Unlock'
      : 'Verify Email & Use Tools'
    : 'Go Back & Use Another Tool';
  return (
    <Grid container className={classes.root}>
      <div>
        <div className={classes.topHeadingsWrapper} style={{ padding: '0 20px' }}>
          <Typography variant="h1" className={classes.topHeading}>
            {isFromUnlockOption
              ? 'Unlock All Options with Quattr’s Content AI '
              : isSignUpNow
              ? 'Go Beyond Free Tools - Try Quattr’s Content AI'
              : 'Generate 10X Clicks with Content AI'}
          </Typography>
          <Typography variant="h3" className={classes.topSubHeading}>
            {isFromUnlockOption
              ? 'The Content Copilot for SEO & Marketing Teams'
              : isSignUpNow
              ? 'The Content Copilot for SEO & Marketing Teams'
              : 'Built for Growth & Marketing Teams'}
          </Typography>
          {!isFromUnlockOption && !isSignUpNow ? (
            <>
              <Typography className={classes.topDescription}>
                Write, optimize & rank high with ease and speed. Learn more about{' '}
                <span className={classes.topDescriptionAnchor} onClick={() => Router.push('/content-ai')}>
                  Quattr Content AI
                </span>
                .
              </Typography>
              <Typography className={classes.topDescriptionNote}>
                Note: Your Content AI free trial account does not grant you additional access to AI Tools.
              </Typography>
            </>
          ) : null}
        </div>
        <div className={classes.freeTrialRoot} style={{ height: 'auto', marginTop: isMobile ? '3vh' : '5vh' }}>
          <Grid item className={classes.freeTrialSectionOneTwo}>
            {/* write your code here */}
            <Typography variant="h1" className={classes.sectionTwoMainHeading}>
              What to expect from your 2-week free trial?
            </Typography>
            <Typography variant="h3" className={classes.sectionTwoMainSubHeading}>
              Revolutionize your SEO & Content Production now!
            </Typography>
            <List className={classes.featureList}>
              <ListItem className={classes.featureItem}>
                <ListItemIcon className={classes.CheckCircleListItemIcon}>
                  <CheckCircleIcon className={classes.featureIcon} />
                </ListItemIcon>
                <Typography variant="body1" className={classes.featureItemText}>
                  Connect your Google Search Console account to get all your keyword data
                </Typography>
              </ListItem>
              <ListItem className={classes.featureItem}>
                <ListItemIcon className={classes.CheckCircleListItemIcon}>
                  <CheckCircleIcon className={classes.featureIcon} />
                </ListItemIcon>
                <Typography variant="body1" className={classes.featureItemText}>
                  Optimize published pages for high SEO rankings
                </Typography>
              </ListItem>
              <ListItem className={classes.featureItem}>
                <ListItemIcon className={classes.CheckCircleListItemIcon}>
                  <CheckCircleIcon className={classes.featureIcon} />
                </ListItemIcon>
                <Typography variant="body1" className={classes.featureItemText}>
                  Conduct unlimited keyword research on topics
                </Typography>
              </ListItem>
              <ListItem className={classes.featureItem}>
                <ListItemIcon className={classes.CheckCircleListItemIcon}>
                  <CheckCircleIcon className={classes.featureIcon} />
                </ListItemIcon>
                <Typography variant="body1" className={classes.featureItemText}>
                  Create new high-quality content faster
                </Typography>
              </ListItem>
            </List>
            <Typography variant="body1" className={classes.brandsHeading}>
              Top SEO and content marketing teams trust Quattr
            </Typography>
            <Box className={classes.brandLogosContainer}>
              {/* Assuming you have these images hosted somewhere, replace the src with your image URLs */}
              {CONSTANTS.brandLogos.map((brandLogo) => (
                <img key={brandLogo.src} src={brandLogo.src} alt={brandLogo.alt} className={classes.brandLogo} />
              ))}
            </Box>
          </Grid>
          <Grid item className={classes.freeTrialSectionOne}>
            {children}
            {isMobile && (isFromUnlockOption || isSignUpNow) && showGoBack && (
              <div className="center-align" style={{ margin: '3vh 0px' }}>
                <Button
                  onClick={() => {
                    trackAnalyticsEvent({
                      eventFor: 'button',
                      buttonText: '',
                      counterName: `Clicked on ${goBackAndContinueLabel}`,
                      isAddCount: true,
                      isAnonymousUser: true,
                      payload: {
                        label: `Clicked on ${goBackAndContinueLabel}`,
                        component_name: COMPONENT_NAMES.contentai_ai_tools,
                        screen_name: SCREEN_NAMES.contentai_ai_tools,
                      },
                    });
                    handleGoBack();
                  }}
                  className={classes.goBack}
                >
                  {goBackAndContinueLabel}
                </Button>
                <Typography className={classes.usageLimit}>
                  (
                  {isFromUnlockOption && !qttr_tools_auth
                    ? 'Unlock the option & use free tool'
                    : 'usage limits will apply'}
                  )
                </Typography>
              </div>
            )}
            {/* <img
              className={classes.bg_image_small}
              src="https://qwa-assets.s3.us-east-2.amazonaws.com/auth-bg2-small.svg"
              alt="onboarding-background"
            /> */}
          </Grid>
        </div>
        {(!isMobile || !showGoBack) && (isFromUnlockOption || isSignUpNow) && (
          <div className="center-align" style={{ margin: '4vh 0px' }}>
            <Box className={signupStyles.dividerContainer}>
              <Divider className={signupStyles.divider} style={{ maxWidth: '93px' }} />
              <Typography variant="caption" className={signupStyles.dividerText}>
                OR keep using free tools instead
              </Typography>
              <Divider className={signupStyles.divider} style={{ maxWidth: '93px' }} />
            </Box>
            <Button
              onClick={() => {
                trackAnalyticsEvent({
                  eventFor: 'button',
                  buttonText: '',
                  counterName: `Clicked on ${goBackAndContinueLabel}`,
                  isAddCount: true,
                  isAnonymousUser: true,
                  payload: {
                    label: `Clicked on ${goBackAndContinueLabel}`,
                    component_name: COMPONENT_NAMES.contentai_ai_tools,
                    screen_name: SCREEN_NAMES.contentai_ai_tools,
                  },
                });
                handleGoBack();
              }}
              className={classes.goBack}
            >
              {goBackAndContinueLabel}
            </Button>
            <Typography className={classes.usageLimit}>
              (
              {isFromUnlockOption && !qttr_tools_auth ? 'Unlock the option & use free tool' : 'usage limits will apply'}
              )
            </Typography>
          </div>
        )}
        {/* {isMobile && (
          <div className="center-align" style={{ margin: '3vh 0px' }}>
            <Button onClick={() => scrollToTop()} className={classes.startFreeTrial}>
              Start Free Trial Now
            </Button>
          </div>
        )} */}
      </div>
    </Grid>
  );
};

const CalendlyEmbed = ({ calendlyLink }) => {
  const [name, setName] = useState('');
  const [isLoaded, setIsLoaded] = useState(false);
  const [email, setEmail] = useState('');

  // Function to handle postMessage events from Calendly
  function handleCalendlyEvent(e) {
    // Check if the event is from Calendly
    if (e.data.event && e.origin === 'https://calendly.com') {
      // Check for the specific event type
      console.log('e.data.event==>', e.data.event);
      if (e.data.event == 'calendly.event_type_viewed') {
        setIsLoaded(true);
      }
      trackAnalyticsEvent({
        eventName: `Calendly - ${e.data.event}`,
        payload: {
          label: `Calendly - ${e.data.event}`,
        },
      });
    }
  }

  // Add the event listener when the component mounts
  React.useEffect(() => {
    window.addEventListener('message', handleCalendlyEvent);
    const email = localStorage.getItem('book-demo-email') || '';
    const name = localStorage.getItem('book-demo-name') || '';
    setName(name);
    setEmail(email);
    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener('message', handleCalendlyEvent);
    };
  }, []);
  React.useEffect(() => {
    const head = document.querySelector('head');
    const script = document.createElement('script');
    script.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js');
    if (head) {
      head.appendChild(script);
    }

    return () => {
      if (head) {
        head.removeChild(script);
      }
    };
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      {!isLoaded && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '634px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#fff',
            zIndex: 10,
          }}
        >
          <QuattrLogoSpinner classes={{}} />
          Loading calendar...
        </div>
      )}
      {name && email && (
        <div
          className="calendly-inline-widget"
          data-url={`${calendlyLink}?name=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}`}
          style={{ minHeight: '634px' }}
        />
      )}
    </div>
  );
};

const BookDemoComponent = ({ classes, children, showGoBack, showCalendly }) => {
  const isMobile = useView('mobileOnly');

  return (
    <Grid container className={classes.root}>
      <div>
        <div className={classes.topHeadingsWrapper}>
          <Typography variant="h1" className={classes.topHeading}>
            Test Drive Quattr AI SEO Suite
          </Typography>
          <Typography variant="h3" className={classes.topSubHeading}>
            The Ultimate AI SEO Platform for Enterprises, Global Brands, & Startups
          </Typography>
        </div>
        {showCalendly ? (
          <CalendlyEmbed
            calendlyLink={process.env.NEXT_PUBLIC_CALENDLY_URL_DEMO || 'https://calendly.com/anuragsinghal/eu'}
          />
        ) : (
          <Grid container className={classes.root} style={{ height: 'auto', marginTop: isMobile ? '3vh' : '5vh' }}>
            <Grid item xs={12} md={6} className={classes.sectionTwo}>
              <Typography variant="h1" className={classes.sectionTwoMainHeading}>
                Book a Free Demo
              </Typography>
              <Typography variant="h3" className={classes.sectionTwoMainSubHeading}>
                Explore how Quattr’s features can help your brand rank faster!
              </Typography>

              <List className={classes.featureList}>
                <ListItem className={classes.featureItem}>
                  <ListItemIcon className={classes.CheckCircleListItemIcon}>
                    <CheckCircleIcon className={classes.featureIcon} />
                  </ListItemIcon>
                  <Typography variant="body1" className={classes.featureItemText}>
                    Get Real-time SEO Reporting & Analytics
                  </Typography>
                </ListItem>
                <ListItem className={classes.featureItem}>
                  <ListItemIcon className={classes.CheckCircleListItemIcon}>
                    <CheckCircleIcon className={classes.featureIcon} />
                  </ListItemIcon>
                  <Typography variant="body1" className={classes.featureItemText}>
                    Compare Ranking Factors with Competitors
                  </Typography>
                </ListItem>
                <ListItem className={classes.featureItem}>
                  <ListItemIcon className={classes.CheckCircleListItemIcon}>
                    <CheckCircleIcon className={classes.featureIcon} />
                  </ListItemIcon>
                  <Typography variant="body1" className={classes.featureItemText}>
                    Scale Content with Generative AI
                  </Typography>
                </ListItem>
                <ListItem className={classes.featureItem}>
                  <ListItemIcon className={classes.CheckCircleListItemIcon}>
                    <CheckCircleIcon className={classes.featureIcon} />
                  </ListItemIcon>
                  <Typography variant="body1" className={classes.featureItemText}>
                    Automate 30+ Key SEO Tasks & Audits
                  </Typography>
                </ListItem>
              </List>
              <Typography variant="body1" className={classes.brandsHeading}>
                Global brands trust & use Quattr
              </Typography>
              <Box className={classes.brandLogosContainer}>
                {/* Assuming you have these images hosted somewhere, replace the src with your image URLs */}
                {CONSTANTS.brandLogos.map((brandLogo) => (
                  <img key={brandLogo.src} src={brandLogo.src} alt={brandLogo.alt} className={classes.brandLogo} />
                ))}
              </Box>
            </Grid>
            <Grid item xs={12} md={6} className={classes.sectionOne}>
              {children}
            </Grid>
          </Grid>
        )}
      </div>
    </Grid>
  );
};

export const BookDemoWrapper = ({ component: Component, classes, user, setShowCalendly, showCalendly }) => {
  const [showGoBack, setGoBack] = useState(true);
  return (
    <BookDemoComponent classes={classes} showGoBack={showGoBack} showCalendly={showCalendly}>
      <Component classes={classes} setGoBack={setGoBack} user={user} setShowCalendly={setShowCalendly} />
    </BookDemoComponent>
  );
};

const OnboardingStylesWrapper = ({ component: Component, classes, user, setFullPageContentAiLoader = (a) => {} }) => {
  const [showGoBack, setGoBack] = useState(true);
  return (
    <OnboardingComponent classes={classes} showGoBack={showGoBack}>
      <Component
        classes={classes}
        setGoBack={setGoBack}
        user={user}
        setFullPageContentAiLoader={setFullPageContentAiLoader}
      />
    </OnboardingComponent>
  );
};
export default OnboardingStylesWrapper;
